(() => {
  const SVG_NS = 'http://www.w3.org/2000/svg';
  const art = { left: 75.590551, right: 755.905512, top: 901.417323, bottom: 984.566929 };
  const signSize = { width: 831.496063, height: 1039.370079 };
  const qrArea = { left: 37.795276, top: 98.498413, size: 755.905512 };
  const artCenter = { x: (art.left + art.right) / 2, y: (art.top + art.bottom) / 2 };
  const iconSize = art.bottom - art.top;
  const textMaxHeight = 22 * 96 / 25.4;
  const gap = 5 * 96 / 25.4;
  const root = document.getElementById('qr-code-configurator');
  const shopifyMode = root.dataset.shopify === 'true';
  const fonts = [
    { id: 'arial-black', name: 'Arial Black', file: 'qr-code-config-v2-font-arial-black.otf', dataKey: 'fontArialBlackUrl', sample: 'Aa 123' },
    { id: 'signpainter', name: 'SignPainter', file: 'qr-code-config-v2-font-signpainter-house-script.otf', dataKey: 'fontSignpainterUrl', sample: 'Aa 123' },
    { id: 'cocktail-shaker', name: 'Cocktail Shaker', file: 'qr-code-config-v2-font-cocktail-shaker.otf', dataKey: 'fontCocktailShakerUrl', sample: 'Aa 123' },
    { id: 'ethnocentric', name: 'Ethnocentric', file: 'qr-code-config-v2-font-ethnocentric-regular.otf', dataKey: 'fontEthnocentricUrl', sample: 'Aa 123' },
    { id: 'orbitron-bold', name: 'Orbitron Bold', file: 'qr-code-config-v2-font-orbitron-bold.otf', dataKey: 'fontOrbitronBoldUrl', sample: 'Aa 123' },
  ];
  const qrStyles = [
    { id: 'square-square', name: 'Square / Square', modules: 'square', eyes: 'square' },
    { id: 'rounded-rounded', name: 'Rounded / Rounded', modules: 'rounded', eyes: 'rounded' },
    { id: 'row-link-tri-round', name: 'Row Link / Tri-Round', modules: 'horizontal', eyes: 'tri-round' },
    { id: 'col-link-tri-round', name: 'Col Link / Tri-Round', modules: 'vertical', eyes: 'tri-round' },
  ];
  let outlineFont = null;
  let selectedFont = 'arial-black';
  let selectedQrStyle = 'row-link-tri-round';
  const fontCache = new Map();

  const platforms = [
    { id: 'instagram', name: 'Instagram', viewBox: '0 0 24 24', icon: '<path d="M7.0301.084c-1.2768.0602-2.1487.264-2.911.5634-.7888.3075-1.4575.72-2.1228 1.3877-.6652.6677-1.075 1.3368-1.3802 2.127-.2954.7638-.4956 1.6365-.552 2.914-.0564 1.2775-.0689 1.6882-.0626 4.947.0062 3.2586.0206 3.6671.0825 4.9473.061 1.2765.264 2.1482.5635 2.9107.308.7889.72 1.4573 1.388 2.1228.6679.6655 1.3365 1.0743 2.1285 1.38.7632.295 1.6361.4961 2.9134.552 1.2773.056 1.6884.069 4.9462.0627 3.2578-.0062 3.668-.0207 4.9478-.0814 1.28-.0607 2.147-.2652 2.9098-.5633.7889-.3086 1.4578-.72 2.1228-1.3881.665-.6682 1.0745-1.3378 1.3795-2.1284.2957-.7632.4966-1.636.552-2.9124.056-1.2809.0692-1.6898.063-4.948-.0063-3.2583-.021-3.6668-.0817-4.9465-.0607-1.2797-.264-2.1487-.5633-2.9117-.3084-.7889-.72-1.4568-1.3876-2.1228C21.2982 1.33 20.628.9208 19.8378.6165 19.074.321 18.2017.1197 16.9244.0645 15.6471.0093 15.236-.005 11.977.0014 8.718.0076 8.31.0215 7.0301.0839m.1402 21.6932c-1.17-.0509-1.8053-.2453-2.2287-.408-.5606-.216-.96-.4771-1.3819-.895-.422-.4178-.6811-.8186-.9-1.378-.1644-.4234-.3624-1.058-.4171-2.228-.0595-1.2645-.072-1.6442-.079-4.848-.007-3.2037.0053-3.583.0607-4.848.05-1.169.2456-1.805.408-2.2282.216-.5613.4762-.96.895-1.3816.4188-.4217.8184-.6814 1.3783-.9003.423-.1651 1.0575-.3614 2.227-.4171 1.2655-.06 1.6447-.072 4.848-.079 3.2033-.007 3.5835.005 4.8495.0608 1.169.0508 1.8053.2445 2.228.408.5608.216.96.4754 1.3816.895.4217.4194.6816.8176.9005 1.3787.1653.4217.3617 1.056.4169 2.2263.0602 1.2655.0739 1.645.0796 4.848.0058 3.203-.0055 3.5834-.061 4.848-.051 1.17-.245 1.8055-.408 2.2294-.216.5604-.4763.96-.8954 1.3814-.419.4215-.8181.6811-1.3783.9-.4224.1649-1.0577.3617-2.2262.4174-1.2656.0595-1.6448.072-4.8493.079-3.2045.007-3.5825-.006-4.848-.0608M16.953 5.5864A1.44 1.44 0 1 0 18.39 4.144a1.44 1.44 0 0 0-1.437 1.4424M5.8385 12.012c.0067 3.4032 2.7706 6.1557 6.173 6.1493 3.4026-.0065 6.157-2.7701 6.1506-6.1733-.0065-3.4032-2.771-6.1565-6.174-6.1498-3.403.0067-6.156 2.771-6.1496 6.1738M8 12.0077a4 4 0 1 1 4.008 3.9921A3.9996 3.9996 0 0 1 8 12.0077"/>' },
    { id: 'youtube', name: 'YouTube', viewBox: '0 0 24 24', icon: '<path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>' },
    { id: 'tiktok', name: 'TikTok', viewBox: '0 0 24 24', icon: '<path d="M12.525.02c1.31-.02 2.61-.01 3.91-.02.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.5-.03-1-.01-1.49.18-1.9 1.12-3.72 2.58-4.96 1.66-1.44 3.98-2.13 6.15-1.72.02 1.48-.04 2.96-.04 4.44-.99-.32-2.15-.23-3.02.37-.63.41-1.11 1.04-1.36 1.75-.21.51-.15 1.07-.14 1.61.24 1.64 1.82 3.02 3.5 2.87 1.12-.01 2.19-.66 2.77-1.61.19-.33.4-.67.41-1.06.1-1.79.06-3.57.07-5.36.01-4.03-.01-8.05.02-12.07z"/>' },
    { id: 'onlyfans', name: 'OnlyFans', viewBox: '0 0 1541 1026', icon: '<path d="M513.5 1025.9 C229.5 1025.9 0 796.6 0 513 C0 229.4 229.5 0.2 513.5 0.2 C641.93 0.2 759.228 47.1049 849.182 124.732 C942.085 12.0178 1061.16 0.2 1282.6 0.2 L1540.4 0.2 C1497.3 190 1348.6 334.9 1090.6 384.8 C1221.1 422.3 1375.1 384.8 1375.1 384.8 C1330.45 579.479 1189.02 701.523 984.995 716.549 C908.124 894.359 733.504 1019.84 528.48 1025.69 C523.504 1025.83 518.51 1025.9 513.5 1025.9 Z M667.5 513 C667.5 428 598.7 359.2 513.5 359.2 C428.3 359.2 359.4 428 359.4 513 C359.4 598.1 428.3 666.9 513.5 666.9 C598.7 666.9 667.5 598.1 667.5 513 Z"/>' },
    { id: 'snapchat', name: 'Snapchat', viewBox: '0 0 24 24', icon: '<path d="M12.206.793c.99 0 4.347.276 5.93 3.821.529 1.193.403 3.219.299 4.847l-.003.06c-.012.18-.022.345-.03.51.075.045.203.09.401.09.3-.016.659-.12 1.033-.301.165-.088.344-.104.464-.104.182 0 .359.029.509.09.45.149.734.479.734.838.015.449-.39.839-1.213 1.168-.089.029-.209.075-.344.119-.45.135-1.139.36-1.333.81-.09.224-.061.524.12.868l.015.015c.06.136 1.526 3.475 4.791 4.014.255.044.435.27.42.509 0 .075-.015.149-.045.225-.24.569-1.273.988-3.146 1.271-.059.091-.12.375-.164.57-.029.179-.074.36-.134.553-.076.271-.27.405-.555.405h-.03c-.135 0-.313-.031-.538-.074-.36-.075-.765-.135-1.273-.135-.3 0-.599.015-.913.074-.6.104-1.123.464-1.723.884-.853.599-1.826 1.288-3.294 1.288-.06 0-.119-.015-.18-.015h-.149c-1.468 0-2.427-.675-3.279-1.288-.599-.42-1.107-.779-1.707-.884-.314-.045-.629-.074-.928-.074-.54 0-.958.089-1.272.149-.211.043-.391.074-.54.074-.374 0-.523-.224-.583-.42-.061-.192-.09-.389-.135-.567-.046-.181-.105-.494-.166-.57-1.918-.222-2.95-.642-3.189-1.226-.031-.063-.052-.15-.055-.225-.015-.243.165-.465.42-.509 3.264-.54 4.73-3.879 4.791-4.02l.016-.029c.18-.345.224-.645.119-.869-.195-.434-.884-.658-1.332-.809-.121-.029-.24-.074-.346-.119-1.107-.435-1.257-.93-1.197-1.273.09-.479.674-.793 1.168-.793.146 0 .27.029.383.074.42.194.789.3 1.104.3.234 0 .384-.06.465-.105l-.046-.569c-.098-1.626-.225-3.651.307-4.837C7.392 1.077 10.739.807 11.727.807l.419-.015h.06z"/>' },
    { id: 'facebook', name: 'Facebook', viewBox: '0 0 32 32', icon: '<path d="M18.7 30V17.4h4.23l.63-4.92H18.7V9.34c0-1.42.4-2.39 2.43-2.39h2.6V2.55A34.8 34.8 0 0 0 19.94 2c-3.76 0-6.34 2.3-6.34 6.52v3.96H9.35v4.92h4.25V30h5.1Z"/>' },
    { id: 'x', name: 'X', viewBox: '0 0 24 24', icon: '<path d="M14.234 10.162 22.977 0h-2.072l-7.591 8.824L7.251 0H.258l9.168 13.343L.258 24H2.33l8.016-9.318L16.749 24h6.993zm-2.837 3.299-.929-1.329L3.076 1.56h3.182l5.965 8.532.929 1.329 7.754 11.09h-3.182z"/>' },
    { id: 'twitch', name: 'Twitch', viewBox: '0 0 24 24', icon: '<path d="M11.571 4.714h1.715v5.143H11.57zm4.715 0H18v5.143h-1.714zM6 0L1.714 4.286v15.428h5.143V24l4.286-4.286h3.428L22.286 12V0zm14.571 11.143l-3.428 3.428h-3.429l-3 3v-3H6.857V1.714h13.714Z"/>' },
    { id: 'whatsapp', name: 'WhatsApp', viewBox: '0 0 24 24', icon: '<path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z"/>' },
    { id: 'discord', name: 'Discord', viewBox: '0 0 24 24', icon: '<path d="M20.317 4.3698a19.7913 19.7913 0 00-4.8851-1.5152.0741.0741 0 00-.0785.0371c-.211.3753-.4447.8648-.6083 1.2495-1.8447-.2762-3.68-.2762-5.4868 0-.1636-.3933-.4058-.8742-.6177-1.2495a.077.077 0 00-.0785-.037 19.7363 19.7363 0 00-4.8852 1.515.0699.0699 0 00-.0321.0277C.5334 9.0458-.319 13.5799.0992 18.0578a.0824.0824 0 00.0312.0561c2.0528 1.5076 4.0413 2.4228 5.9929 3.0294a.0777.0777 0 00.0842-.0276c.4616-.6304.8731-1.2952 1.226-1.9942a.076.076 0 00-.0416-.1057c-.6528-.2476-1.2743-.5495-1.8722-.8923a.077.077 0 01-.0076-.1277c.1258-.0943.2517-.1923.3718-.2914a.0743.0743 0 01.0776-.0105c3.9278 1.7933 8.18 1.7933 12.0614 0a.0739.0739 0 01.0785.0095c.1202.099.246.1981.3728.2924a.077.077 0 01-.0066.1276 12.2986 12.2986 0 01-1.873.8914.0766.0766 0 00-.0407.1067c.3604.698.7719 1.3628 1.225 1.9932a.076.076 0 00.0842.0286c1.961-.6067 3.9495-1.5219 6.0023-3.0294a.077.077 0 00.0313-.0552c.5004-5.177-.8382-9.6739-3.5485-13.6604a.061.061 0 00-.0312-.0286zM8.02 15.3312c-1.1825 0-2.1569-1.0857-2.1569-2.419 0-1.3332.9555-2.4189 2.157-2.4189 1.2108 0 2.1757 1.0952 2.1568 2.419 0 1.3332-.9555 2.4189-2.1569 2.4189zm7.9748 0c-1.1825 0-2.1569-1.0857-2.1569-2.419 0-1.3332.9554-2.4189 2.1569-2.4189 1.2108 0 2.1757 1.0952 2.1568 2.419 0 1.3332-.946 2.4189-2.1568 2.4189Z"/>' },
    { id: 'reddit', name: 'Reddit', viewBox: '0 0 24 24', icon: '<path d="M12 0C5.373 0 0 5.373 0 12c0 3.314 1.343 6.314 3.515 8.485l-2.286 2.286C.775 23.225 1.097 24 1.738 24H12c6.627 0 12-5.373 12-12S18.627 0 12 0Zm4.388 3.199c1.104 0 1.999.895 1.999 1.999 0 1.105-.895 2-1.999 2-.946 0-1.739-.657-1.947-1.539v.002c-1.147.162-2.032 1.15-2.032 2.341v.007c1.776.067 3.4.567 4.686 1.363.473-.363 1.064-.58 1.707-.58 1.547 0 2.802 1.254 2.802 2.802 0 1.117-.655 2.081-1.601 2.531-.088 3.256-3.637 5.876-7.997 5.876-4.361 0-7.905-2.617-7.998-5.87-.954-.447-1.614-1.415-1.614-2.538 0-1.548 1.255-2.802 2.803-2.802.645 0 1.239.218 1.712.585 1.275-.79 2.881-1.291 4.64-1.365v-.01c0-1.663 1.263-3.034 2.88-3.207.188-.911.993-1.595 1.959-1.595Zm-8.085 8.376c-.784 0-1.459.78-1.506 1.797-.047 1.016.64 1.429 1.426 1.429.786 0 1.371-.369 1.418-1.385.047-1.017-.553-1.841-1.338-1.841Zm7.406 0c-.786 0-1.385.824-1.338 1.841.047 1.017.634 1.385 1.418 1.385.785 0 1.473-.413 1.426-1.429-.046-1.017-.721-1.797-1.506-1.797Zm-3.703 4.013c-.974 0-1.907.048-2.77.135-.147.015-.241.168-.183.305.483 1.154 1.622 1.964 2.953 1.964 1.33 0 2.47-.81 2.953-1.964.057-.137-.037-.29-.184-.305-.863-.087-1.795-.135-2.769-.135Z"/>' },
    { id: 'fansly', name: 'Fansly', viewBox: '0 0 180 180', icon: '<g transform="translate(0.000000,180.000000) scale(0.100000,-0.100000)" stroke="none"><path d="M480 1523 c-127 -17 -243 -93 -296 -196 -51 -98 -54 -228 -6 -328 27 -56 70 -103 361 -394 289 -288 334 -329 361 -330 28 -1 59 26 277 244 l245 244 -197 197 -196 196 85 81 c59 57 96 85 123 92 123 33 231 -46 234 -172 2 -66 -14 -97 -85 -167 -31 -30 -56 -58 -56 -62 0 -8 68 -79 106 -111 21 -18 23 -17 88 50 42 42 79 93 99 133 29 58 32 73 32 155 0 76 -4 99 -27 146 -93 200 -315 276 -513 177 -23 -12 -157 -136 -322 -300 -169 -169 -286 -278 -292 -273 -7 4 -42 38 -79 76 -80 83 -104 136 -91 206 20 108 122 172 228 143 43 -11 41 -10 123 -89 l56 -54 61 61 c34 33 61 64 61 69 0 17 -134 139 -175 160 -63 33 -153 53 -205 46z m523 -610 c122 -86 102 -260 -35 -318 -75 -31 -163 -7 -214 60 -38 51 -45 134 -15 192 50 98 175 130 264 66z"/><path d="M849 869 c-34 -13 -68 -75 -63 -117 14 -116 168 -143 218 -38 27 58 18 96 -23 96 -33 0 -51 17 -51 47 0 19 -5 23 -27 22 -16 0 -40 -5 -54 -10z"/></g>' },
    { id: 'kick', name: 'Kick', viewBox: '0 0 24 24', icon: '<path d="M1.333 0h8v5.333H12V2.667h2.667V0h8v8H20v2.667h-2.667v2.666H20V16h2.667v8h-8v-2.667H12v-2.666H9.333V24h-8Z"/>' },
    { id: 'threads', name: 'Threads', viewBox: '0 0 24 24', icon: '<path d="M18.263 11.097c-.03-3.486-1.92-5.586-5.111-5.586-2.13 0-3.922.963-4.863 2.499l2.062 1.438c.535-.843 1.272-1.543 2.628-1.543 1.528 0 2.318.85 2.544 2.431a15 15 0 0 0-2.236-.173c-4.125 0-6.068 1.867-6.068 4.336s1.943 3.99 4.804 3.99c3.139 0 5.013-2.115 5.781-4.735.798.361 1.348 1.204 1.348 2.47 0 3.387-3.907 5.232-7.22 5.232-4.885 0-8.077-3.207-8.077-8.424 0-6.392 4.223-10.487 9.9-10.487 3.808 0 5.69 1.671 6.97 3.914l2.108-1.475C21.44 2.078 18.331 0 13.663 0 6.227 0 1.168 5.277 1.168 12.934c0 7 4.953 11.066 10.856 11.066 4.878 0 9.809-2.846 9.809-7.716 0-2.545-1.46-4.231-3.569-5.187m-6.33 4.855c-1.077 0-2.026-.512-2.026-1.453 0-1.483 1.822-1.934 3.606-1.934.678 0 1.34.045 1.927.173-.422 1.927-1.671 3.215-3.508 3.214Z"/>' },
    { id: 'pinterest', name: 'Pinterest', viewBox: '0 0 24 24', icon: '<path d="M12.017 0C5.396 0 .029 5.367.029 11.987c0 5.079 3.158 9.417 7.618 11.162-.105-.949-.199-2.403.041-3.439.219-.937 1.406-5.957 1.406-5.957s-.359-.72-.359-1.781c0-1.663.967-2.911 2.168-2.911 1.024 0 1.518.769 1.518 1.688 0 1.029-.653 2.567-.992 3.992-.285 1.193.6 2.165 1.775 2.165 2.128 0 3.768-2.245 3.768-5.487 0-2.861-2.063-4.869-5.008-4.869-3.41 0-5.409 2.562-5.409 5.199 0 1.033.394 2.143.889 2.741.099.12.112.225.085.345-.09.375-.293 1.199-.334 1.363-.053.225-.172.271-.401.165-1.495-.69-2.433-2.878-2.433-4.646 0-3.776 2.748-7.252 7.92-7.252 4.158 0 7.392 2.967 7.392 6.923 0 4.135-2.607 7.462-6.233 7.462-1.214 0-2.354-.629-2.758-1.379l-.749 2.848c-.269 1.045-1.004 2.352-1.498 3.146 1.123.345 2.306.535 3.55.535 6.607 0 11.985-5.365 11.985-11.987C23.97 5.39 18.592.026 11.985.026L12.017 0z"/>' },
    { id: 'linkedin', name: 'LinkedIn', viewBox: '0 0 448 512', icon: '<path d="M100.28 448H7.4V148.9h92.88zM53.79 108.1C24.09 108.1 0 83.5 0 53.8a53.79 53.79 0 0 1 107.58 0c0 29.7-24.1 54.3-53.79 54.3zM447.9 448h-92.68V302.4c0-34.7-.7-79.2-48.29-79.2-48.29 0-55.69 37.7-55.69 76.7V448h-92.78V148.9h89.08v40.8h1.3c12.4-23.5 42.69-48.3 87.88-48.3 94 0 111.28 61.9 111.28 142.3V448z"/>' },
    { id: 'messenger', name: 'Messenger', viewBox: '0 0 24 24', icon: '<path d="M12 0C5.24 0 0 4.952 0 11.64c0 3.499 1.434 6.521 3.769 8.61a.96.96 0 0 1 .323.683l.065 2.135a.96.96 0 0 0 1.347.85l2.381-1.053a.96.96 0 0 1 .641-.046A13 13 0 0 0 12 23.28c6.76 0 12-4.952 12-11.64S18.76 0 12 0m6.806 7.44c.522-.03.971.567.63 1.094l-4.178 6.457a.707.707 0 0 1-.977.208l-3.87-2.504a.44.44 0 0 0-.49.007l-4.363 3.01c-.637.438-1.415-.317-.995-.966l4.179-6.457a.706.706 0 0 1 .977-.21l3.87 2.505c.15.097.344.094.491-.007l4.362-3.008a.7.7 0 0 1 .364-.13"/>' },
    { id: 'patreon', name: 'Patreon', viewBox: '0 0 24 24', icon: '<path d="M22.957 7.21c-.004-3.064-2.391-5.576-5.191-6.482-3.478-1.125-8.064-.962-11.384.604C2.357 3.231 1.093 7.391 1.046 11.54c-.039 3.411.302 12.396 5.369 12.46 3.765.047 4.326-4.804 6.068-7.141 1.24-1.662 2.836-2.132 4.801-2.618 3.376-.836 5.678-3.501 5.673-7.031Z"/>' },
    { id: 'kofi', name: 'Ko-fi', viewBox: '0 0 24 24', icon: '<path d="M11.351 2.715c-2.7 0-4.986.025-6.83.26C2.078 3.285 0 5.154 0 8.61c0 3.506.182 6.13 1.585 8.493 1.584 2.701 4.233 4.182 7.662 4.182h.83c4.209 0 6.494-2.234 7.637-4a9.5 9.5 0 0 0 1.091-2.338C21.792 14.688 24 12.22 24 9.208v-.415c0-3.247-2.13-5.507-5.792-5.87-1.558-.156-2.65-.208-6.857-.208m0 1.947c4.208 0 5.09.052 6.571.182 2.624.311 4.13 1.584 4.13 4v.39c0 2.156-1.792 3.844-3.87 3.844h-.935l-.156.649c-.208 1.013-.597 1.818-1.039 2.546-.909 1.428-2.545 3.064-5.922 3.064h-.805c-2.571 0-4.831-.883-6.078-3.195-1.09-2-1.298-4.155-1.298-7.506 0-2.181.857-3.402 3.012-3.714 1.533-.233 3.559-.26 6.39-.26m6.547 2.287c-.416 0-.65.234-.65.546v2.935c0 .311.234.545.65.545 1.324 0 2.051-.754 2.051-2s-.727-2.026-2.052-2.026m-10.39.182c-1.818 0-3.013 1.48-3.013 3.142 0 1.533.858 2.857 1.949 3.897.727.701 1.87 1.429 2.649 1.896a1.47 1.47 0 0 0 1.507 0c.78-.467 1.922-1.195 2.623-1.896 1.117-1.039 1.974-2.364 1.974-3.897 0-1.662-1.247-3.142-3.039-3.142-1.065 0-1.792.545-2.338 1.298-.493-.753-1.246-1.298-2.312-1.298"/>' },
    { id: 'buymeacoffee', name: 'Buy Me a Coffee', viewBox: '0 0 24 24', icon: '<path d="M20.216 6.415l-.132-.666c-.119-.598-.388-1.163-1.001-1.379-.197-.069-.42-.098-.57-.241-.152-.143-.196-.366-.231-.572-.065-.378-.125-.756-.192-1.133-.057-.325-.102-.69-.25-.987-.195-.4-.597-.634-.996-.788a5.723 5.723 0 00-.626-.194c-1-.263-2.05-.36-3.077-.416a25.834 25.834 0 00-3.7.062c-.915.083-1.88.184-2.75.5-.318.116-.646.256-.888.501-.297.302-.393.77-.177 1.146.154.267.415.456.692.58.36.162.737.284 1.123.366 1.075.238 2.189.331 3.287.37 1.218.05 2.437.01 3.65-.118.299-.033.598-.073.896-.119.352-.054.578-.513.474-.834-.124-.383-.457-.531-.834-.473-.466.074-.96.108-1.382.146-1.177.08-2.358.082-3.536.006a22.228 22.228 0 01-1.157-.107c-.086-.01-.18-.025-.258-.036-.243-.036-.484-.08-.724-.13-.111-.027-.111-.185 0-.212h.005c.277-.06.557-.108.838-.147h.002c.131-.009.263-.032.394-.048a25.076 25.076 0 013.426-.12c.674.019 1.347.067 2.017.144l.228.031c.267.04.533.088.798.145.392.085.895.113 1.07.542.055.137.08.288.111.431l.319 1.484a.237.237 0 01-.199.284h-.003c-.037.006-.075.01-.112.015a36.704 36.704 0 01-4.743.295 37.059 37.059 0 01-4.699-.304c-.14-.017-.293-.042-.417-.06-.326-.048-.649-.108-.973-.161-.393-.065-.768-.032-1.123.161-.29.16-.527.404-.675.701-.154.316-.199.66-.267 1-.069.34-.176.707-.135 1.056.087.753.613 1.365 1.37 1.502a39.69 39.69 0 0011.343.376.483.483 0 01.535.53l-.071.697-1.018 9.907c-.041.41-.047.832-.125 1.237-.122.637-.553 1.028-1.182 1.171-.577.131-1.165.2-1.756.205-.656.004-1.31-.025-1.966-.022-.699.004-1.556-.06-2.095-.58-.475-.458-.54-1.174-.605-1.793l-.731-7.013-.322-3.094c-.037-.351-.286-.695-.678-.678-.336.015-.718.3-.678.679l.228 2.185.949 9.112c.147 1.344 1.174 2.068 2.446 2.272.742.12 1.503.144 2.257.156.966.016 1.942.053 2.892-.122 1.408-.258 2.465-1.198 2.616-2.657.34-3.332.683-6.663 1.024-9.995l.215-2.087a.484.484 0 01.39-.426c.402-.078.787-.212 1.074-.518.455-.488.546-1.124.385-1.766zm-1.478.772c-.145.137-.363.201-.578.233-2.416.359-4.866.54-7.308.46-1.748-.06-3.477-.254-5.207-.498-.17-.024-.353-.055-.47-.18-.22-.236-.111-.71-.054-.995.052-.26.152-.609.463-.646.484-.057 1.046.148 1.526.22.577.088 1.156.159 1.737.212 2.48.226 5.002.19 7.472-.14.45-.06.899-.13 1.345-.21.399-.072.84-.206 1.08.206.166.281.188.657.162.974a.544.544 0 01-.169.364zm-6.159 3.9c-.862.37-1.84.788-3.109.788a5.884 5.884 0 01-1.569-.217l.877 9.004c.065.78.717 1.38 1.5 1.38 0 0 1.243.065 1.658.065.447 0 1.786-.065 1.786-.065.783 0 1.434-.6 1.499-1.38l.94-9.95a3.996 3.996 0 00-1.322-.238c-.826 0-1.491.284-2.26.613z"/>' },
    { id: 'soundcloud', name: 'SoundCloud', viewBox: '0 0 24 24', icon: '<path d="M23.999 14.165c-.052 1.796-1.612 3.169-3.4 3.169h-8.18a.68.68 0 0 1-.675-.683V7.862a.747.747 0 0 1 .452-.724s.75-.513 2.333-.513a5.364 5.364 0 0 1 2.763.755 5.433 5.433 0 0 1 2.57 3.54c.282-.08.574-.121.868-.12.884 0 1.73.358 2.347.992s.948 1.49.922 2.373ZM10.721 8.421c.247 2.98.427 5.697 0 8.672a.264.264 0 0 1-.53 0c-.395-2.946-.22-5.718 0-8.672a.264.264 0 0 1 .53 0ZM9.072 9.448c.285 2.659.37 4.986-.006 7.655a.277.277 0 0 1-.55 0c-.331-2.63-.256-5.02 0-7.655a.277.277 0 0 1 .556 0Zm-1.663-.257c.27 2.726.39 5.171 0 7.904a.266.266 0 0 1-.532 0c-.38-2.69-.257-5.21 0-7.904a.266.266 0 0 1 .532 0Zm-1.647.77a26.108 26.108 0 0 1-.008 7.147.272.272 0 0 1-.542 0 27.955 27.955 0 0 1 0-7.147.275.275 0 0 1 .55 0Zm-1.67 1.769c.421 1.865.228 3.5-.029 5.388a.257.257 0 0 1-.514 0c-.21-1.858-.398-3.549 0-5.389a.272.272 0 0 1 .543 0Zm-1.655-.273c.388 1.897.26 3.508-.01 5.412-.026.28-.514.283-.54 0-.244-1.878-.347-3.54-.01-5.412a.283.283 0 0 1 .56 0Zm-1.668.911c.4 1.268.257 2.292-.026 3.572a.257.257 0 0 1-.514 0c-.241-1.262-.354-2.312-.023-3.572a.283.283 0 0 1 .563 0Z"/>' },
    { id: 'bandcamp', name: 'Bandcamp', viewBox: '0 0 24 24', icon: '<path d="M0 18.75l7.437-13.5H24l-7.438 13.5H0z"/>' },
    { id: 'spotify', name: 'Spotify', viewBox: '0 0 24 24', icon: '<path d="M12 0C5.4 0 0 5.4 0 12s5.4 12 12 12 12-5.4 12-12S18.66 0 12 0zm5.521 17.34c-.24.359-.66.48-1.021.24-2.82-1.74-6.36-2.101-10.561-1.141-.418.122-.779-.179-.899-.539-.12-.421.18-.78.54-.9 4.56-1.021 8.52-.6 11.64 1.32.42.18.479.659.301 1.02zm1.44-3.3c-.301.42-.841.6-1.262.3-3.239-1.98-8.159-2.58-11.939-1.38-.479.12-1.02-.12-1.14-.6-.12-.48.12-1.021.6-1.141C9.6 9.9 15 10.561 18.72 12.84c.361.181.54.78.241 1.2zm.12-3.36C15.24 8.4 8.82 8.16 5.16 9.301c-.6.179-1.2-.181-1.38-.721-.18-.601.18-1.2.72-1.381 4.26-1.26 11.28-1.02 15.721 1.621.539.3.719 1.02.419 1.56-.299.421-1.02.599-1.559.3z"/>' },
    { id: 'nextdoor', name: 'Nextdoor', viewBox: '0 0 180 180', pickerViewBox: '34 45 112 90', icon: '<path d="M71.2012 60.1136V48.2368H55.7597V69.8109L37.4592 81.3082L45.6741 94.385L55.8038 88.0231V131.784H124.4V88.0231L134.529 94.385L142.744 81.3082L90.1017 48.2368L71.2012 60.1136Z"/>' },
  ];

  const input = root.querySelector('#username');
  const qrInput = root.querySelector('#qr-url');
  const qrStatus = root.querySelector('#qr-url-status');
  const picker = root.querySelector('#icon-grid');
  const fontPicker = root.querySelector('#font-grid');
  const qrStylePicker = root.querySelector('#qr-style-grid');
  const sign = root.querySelector('#sign-preview');
  const rgbSettings = getComputedStyle(sign);
  const rgbCycle = rgbSettings.getPropertyValue('--rgb-cycle').trim();
  const rgbSpan = Number.parseFloat(rgbSettings.getPropertyValue('--rgb-span'));
  const rgbGradient = sign.querySelector('#preview-rgb-flow');
  const rgbAnimations = rgbGradient.querySelectorAll('animate');
  rgbGradient.setAttribute('x2', String(rgbSpan));
  rgbAnimations[0].setAttribute('to', String(-rgbSpan));
  rgbAnimations[1].setAttribute('from', String(rgbSpan));
  rgbAnimations.forEach((animation) => animation.setAttribute('dur', rgbCycle));
  const addButton = root.querySelector('#add-button');
  const scrollAmount = () => Math.max(160, picker.clientWidth * 0.72);
  let selected = '';
  let dynamicLayer;
  let previewMaskArtwork;

  function iconMarkup(platform) {
    const viewBox = platform.pickerViewBox || platform.viewBox || '0 0 32 32';
    return `<svg viewBox="${viewBox}" aria-hidden="true" focusable="false">${platform.icon}</svg>`;
  }

  function qrStylePreviewMarkup(style) {
    const eyeCorners = [4.8, 4.8, 4.8, 4.8];
    if (style.eyes === 'square') eyeCorners.fill(0);
    if (style.eyes === 'tri-round') eyeCorners[2] = 0;
    const innerCorners = eyeCorners.map((radius) => Math.max(0, radius - 3));
    const centerCorners = eyeCorners.map((radius) => Math.max(0, Math.min(1.2, radius - 0.9)));
    const eye = [
      roundedRectPath(0, 3, 16, 16, eyeCorners),
      roundedRectPath(3, 6, 10, 10, innerCorners),
      roundedRectPath(6, 9, 4, 4, centerCorners)
    ].join(' ');
    const modules = [[20, 2, 4, 4], [27, 2, 4, 4], [20, 9, 5, 4], [28, 9, 5, 4], [20, 17, 4, 4], [27, 17, 5, 4]];
    const moduleShapes = modules.map(([x, y, width, height]) => {
      if (style.modules === 'horizontal') return roundedRectPath(x, y + 0.5, width, 3, [1.5, 1.5, 1.5, 1.5]);
      if (style.modules === 'vertical') return roundedRectPath(x + 0.5, y, 3, height, [1.5, 1.5, 1.5, 1.5]);
      const radius = style.modules === 'rounded' ? 2 : 0;
      return roundedRectPath(x, y, width, height, [radius, radius, radius, radius]);
    }).join(' ');
    return `<svg class="qr-style-sample" viewBox="0 0 34 24" aria-hidden="true" focusable="false"><path fill-rule="evenodd" d="${eye}"/><path d="${moduleShapes}"/></svg>`;
  }

  function normalizeQrUrl(value) {
    let candidate = value.trim();
    if (!candidate || candidate.length > 500) return { valid: false, normalized: '' };
    if (!/^[a-z][a-z0-9+.-]*:\/\//i.test(candidate)) candidate = `https://${candidate}`;
    try {
      const parsed = new URL(candidate);
      if (!['http:', 'https:'].includes(parsed.protocol) || !parsed.hostname || parsed.username || parsed.password || /\s/.test(parsed.hostname)) {
        return { valid: false, normalized: '' };
      }
      return { valid: true, normalized: parsed.href };
    } catch {
      return { valid: false, normalized: '' };
    }
  }

  function updateQrValidity() {
    const result = normalizeQrUrl(qrInput.value);
    const message = !qrInput.value.trim()
      ? 'Enter a website or link to make your QR code.'
      : qrInput.value.length > 500
        ? 'Use a link with 500 characters or fewer.'
        : result.valid
          ? ''
          : 'Enter a valid http or https website link.';
    qrInput.setCustomValidity(message);
    qrInput.setAttribute('aria-invalid', String(Boolean(message)));
    qrStatus.textContent = result.valid ? 'QR code preview updated.' : message;
    return result;
  }

  function refreshPreviewMask() {
    if (!previewMaskArtwork) return;
    previewMaskArtwork.replaceChildren();
    ['shallow-etch', 'dynamic-shallow-etch'].forEach((id) => {
      const source = sign.querySelector(`#${id}`);
      if (!source) return;
      const copy = source.cloneNode(true);
      copy.removeAttribute('id');
      copy.querySelectorAll('[id]').forEach((node) => node.removeAttribute('id'));
      copy.removeAttribute('style');
      copy.querySelectorAll('[style]').forEach((node) => node.removeAttribute('style'));
      copy.classList.add('preview-mask-art');
      previewMaskArtwork.append(copy);
    });
  }

  function choose(platformId) {
    selected = platformId;
    picker.querySelectorAll('.icon-option').forEach((button) => {
      const active = button.dataset.platform === selected;
      button.setAttribute('aria-checked', String(active));
      button.tabIndex = active ? 0 : -1;
    });
    syncCartProperties();
    updatePreview();
  }

  function syncCartProperties() {
    const iconProperty = root.querySelector('[data-config-property="icon"]');
    const fontProperty = root.querySelector('[data-config-property="font"]');
    const qrUrlProperty = root.querySelector('[data-config-property="qr-url"]');
    const qrStyleProperty = root.querySelector('[data-config-property="qr-style"]');
    if (iconProperty) iconProperty.value = platforms.find((item) => item.id === selected)?.name || '';
    if (fontProperty) fontProperty.value = fonts.find((item) => item.id === selectedFont)?.name || '';
    if (qrUrlProperty) qrUrlProperty.value = normalizeQrUrl(qrInput.value).normalized;
    if (qrStyleProperty) qrStyleProperty.value = qrStyles.find((item) => item.id === selectedQrStyle)?.name || '';
  }

  function loadFont(fontId) {
    if (fontCache.has(fontId)) return fontCache.get(fontId);
    const option = fonts.find((font) => font.id === fontId);
    const request = fetch(root.dataset[option.dataKey] || option.file)
      .then((response) => {
        if (!response.ok) throw new Error(`Font request failed: ${response.status}`);
        return response.arrayBuffer();
      })
      .then((fontData) => opentype.parse(fontData))
      .catch((error) => {
        fontCache.delete(fontId);
        throw error;
      });
    fontCache.set(fontId, request);
    return request;
  }

  async function chooseFont(fontId) {
    selectedFont = fontId;
    fontPicker.querySelectorAll('.font-option').forEach((button) => {
      const active = button.dataset.font === selectedFont;
      button.setAttribute('aria-checked', String(active));
      button.tabIndex = active ? 0 : -1;
    });
    syncCartProperties();
    try {
      const font = await loadFont(fontId);
      if (selectedFont === fontId) {
        outlineFont = font;
        updatePreview();
      }
    } catch (error) {
      console.error(`Could not load ${fonts.find((font) => font.id === fontId).name}.`, error);
    }
  }

  function chooseQrStyle(styleId) {
    selectedQrStyle = styleId;
    qrStylePicker.querySelectorAll('.qr-style-option').forEach((button) => {
      const active = button.dataset.qrStyle === selectedQrStyle;
      button.setAttribute('aria-checked', String(active));
      button.tabIndex = active ? 0 : -1;
    });
    syncCartProperties();
    updatePreview();
  }

  // Boolean geometry is shared by the preview and manufacturing export.
  const geometry = new paper.PaperScope();
  new geometry.Project();
  geometry.view.autoUpdate = false;
  let mergedTextCache = null;

  function mergeTextContours(outline) {
    const sourceData = outline.toPathData({ decimalPlaces: 5, flipY: false });
    if (mergedTextCache?.source === sourceData) return mergedTextCache.path;
    const source = new geometry.CompoundPath({
      pathData: sourceData,
      fillRule: 'nonzero',
      insert: false
    });
    const merged = source.unite(source, { insert: false });
    const path = merged.getPathData(null, 5);
    source.remove();
    merged.remove();
    mergedTextCache = { source: sourceData, path };
    return path;
  }

  function closeFontContours(path) {
    const commands = [];
    let contourOpen = false;
    path.commands.forEach((command) => {
      if (command.type === 'M' && contourOpen) commands.push({ type: 'Z' });
      if (command.type === 'M') contourOpen = true;
      if (command.type === 'Z') contourOpen = false;
      commands.push(command);
    });
    if (contourOpen) commands.push({ type: 'Z' });
    path.commands = commands;
    return path;
  }

  function protectedQrModule(row, col, count) {
    return (
      (row <= 6 && col <= 6) ||
      (row <= 6 && col >= count - 7) ||
      (row >= count - 7 && col <= 6)
    );
  }

  function roundedRectPath(x, y, width, height, radii) {
    const [tl, tr, br, bl] = radii.map((radius) => Math.max(0, Math.min(radius, width / 2, height / 2)));
    const parts = [`M ${x + tl} ${y}`];
    if (tr) parts.push(`H ${x + width - tr} A ${tr} ${tr} 0 0 1 ${x + width} ${y + tr}`);
    else parts.push(`H ${x + width}`);
    if (br) parts.push(`V ${y + height - br} A ${br} ${br} 0 0 1 ${x + width - br} ${y + height}`);
    else parts.push(`V ${y + height}`);
    if (bl) parts.push(`H ${x + bl} A ${bl} ${bl} 0 0 1 ${x} ${y + height - bl}`);
    else parts.push(`H ${x}`);
    if (tl) parts.push(`V ${y + tl} A ${tl} ${tl} 0 0 1 ${x + tl} ${y}`);
    else parts.push(`V ${y}`);
    parts.push('Z');
    return parts.join(' ');
  }

  function appendQrArtwork(target, value) {
    if (typeof window.qrcode !== 'function') throw new Error('The QR code generator did not load.');
    const qr = window.qrcode(0, 'Q');
    qr.addData(value, 'Byte');
    qr.make();
    const count = qr.getModuleCount();
    const quietZone = 0;
    const cell = qrArea.size / (count + quietZone * 2);
    const style = qrStyles.find((item) => item.id === selectedQrStyle) || qrStyles[0];
    const modules = [];

    if (style.modules === 'square' || style.modules === 'rounded') {
      const inset = style.modules === 'rounded' ? cell * 0.04 : 0;
      const size = cell - inset * 2;
      const radius = style.modules === 'rounded' ? cell * 0.26 : 0;
      for (let row = 0; row < count; row += 1) {
        for (let col = 0; col < count; col += 1) {
          if (!qr.isDark(row, col) || protectedQrModule(row, col, count)) continue;
          const x = qrArea.left + (col + quietZone) * cell + inset;
          const y = qrArea.top + (row + quietZone) * cell + inset;
          modules.push(roundedRectPath(x, y, size, size, [radius, radius, radius, radius]));
        }
      }
    } else if (style.modules === 'horizontal') {
      const inset = cell * 0.08;
      const height = cell - inset * 2;
      for (let row = 0; row < count; row += 1) {
        let col = 0;
        while (col < count) {
          if (!qr.isDark(row, col) || protectedQrModule(row, col, count)) { col += 1; continue; }
          const runStart = col;
          while (col < count && qr.isDark(row, col) && !protectedQrModule(row, col, count)) col += 1;
          modules.push(roundedRectPath(
            qrArea.left + (runStart + quietZone) * cell + inset,
            qrArea.top + (row + quietZone) * cell + inset,
            (col - runStart) * cell - inset * 2,
            height,
            [height / 2, height / 2, height / 2, height / 2]
          ));
        }
      }
    } else {
      const inset = cell * 0.08;
      const width = cell - inset * 2;
      for (let col = 0; col < count; col += 1) {
        let row = 0;
        while (row < count) {
          if (!qr.isDark(row, col) || protectedQrModule(row, col, count)) { row += 1; continue; }
          const runStart = row;
          while (row < count && qr.isDark(row, col) && !protectedQrModule(row, col, count)) row += 1;
          modules.push(roundedRectPath(
            qrArea.left + (col + quietZone) * cell + inset,
            qrArea.top + (runStart + quietZone) * cell + inset,
            width,
            (row - runStart) * cell - inset * 2,
            [width / 2, width / 2, width / 2, width / 2]
          ));
        }
      }
    }

    if (modules.length) {
      const modulePath = document.createElementNS(SVG_NS, 'path');
      modulePath.setAttribute('d', modules.join(' '));
      modulePath.setAttribute('fill-rule', 'evenodd');
      modulePath.setAttribute('class', 'dynamic-qr-modules');
      target.append(modulePath);
    }

    const eyePath = document.createElementNS(SVG_NS, 'path');
    const eyes = [];
    const origins = [[0, 0, 2], [count - 7, 0, 3], [0, count - 7, 1]];
    const eyeRadius = style.eyes === 'square' ? 0 : 1.7 * cell;
    origins.forEach(([col, row, squareCorner]) => {
      const x = qrArea.left + (col + quietZone) * cell;
      const y = qrArea.top + (row + quietZone) * cell;
      const corners = [eyeRadius, eyeRadius, eyeRadius, eyeRadius];
      if (style.eyes === 'tri-round') corners[squareCorner] = 0;
      const innerCorners = corners.map((radius) => Math.max(0, radius - cell));
      const centerCorners = corners.map((radius) => Math.max(0, Math.min(cell * 0.62, radius - (cell * 0.3))));
      eyes.push(roundedRectPath(x, y, 7 * cell, 7 * cell, corners));
      eyes.push(roundedRectPath(x + cell, y + cell, 5 * cell, 5 * cell, innerCorners));
      eyes.push(roundedRectPath(x + 2 * cell, y + 2 * cell, 3 * cell, 3 * cell, centerCorners));
    });
    eyePath.setAttribute('d', eyes.join(' '));
    eyePath.setAttribute('fill-rule', 'evenodd');
    eyePath.setAttribute('class', 'dynamic-qr-eyes');
    target.append(eyePath);
  }

  function updatePreview() {
    if (!dynamicLayer) return;
    dynamicLayer.replaceChildren();
    const qrResult = updateQrValidity();
    if (qrResult.valid) {
      try {
        appendQrArtwork(dynamicLayer, qrResult.normalized);
      } catch (error) {
        console.error('Could not generate the QR code.', error);
      }
    }
    const textValue = input.value;
    const platform = platforms.find((item) => item.id === selected);
    let iconBox = null;
    let iconScale = 1;
    if (platform) {
      const measuringGroup = document.createElementNS(SVG_NS, 'g');
      measuringGroup.innerHTML = platform.icon;
      dynamicLayer.append(measuringGroup);
      iconBox = measuringGroup.getBBox();
      measuringGroup.remove();
      iconScale = iconSize / Math.max(1, iconBox.width, iconBox.height);
    }
    let pathData = '';
    let pathBounds = null;
    let width = 0;
    if (textValue.length && outlineFont) {
      const nominalPath = outlineFont.getPath(textValue, 0, 0, 100, { kerning: true });
      const nominalBounds = nominalPath.getBoundingBox();
      const nominalWidth = nominalBounds.x2 - nominalBounds.x1;
      const nominalHeight = nominalBounds.y2 - nominalBounds.y1;
      if (nominalWidth > 0 && nominalHeight > 0) {
        const maxWidth = art.right - art.left - (platform ? iconSize + gap : 0);
        const scale = Math.min(textMaxHeight / nominalHeight, maxWidth / nominalWidth);
        const outline = closeFontContours(outlineFont.getPath(textValue, 0, 0, 100 * scale, { kerning: true }));
        pathBounds = outline.getBoundingBox();
        pathData = mergeTextContours(outline);
        width = pathBounds.x2 - pathBounds.x1;
      }
    }
    const hasOutlinedText = Boolean(pathData && pathBounds && width > 0);
    const iconWidth = platform ? iconSize : 0;
    const spacer = platform && hasOutlinedText ? gap : 0;
    const totalWidth = iconWidth + spacer + width;
    const start = artCenter.x - totalWidth / 2;
    if (platform) {
      const iconGroup = document.createElementNS(SVG_NS, 'g');
      const iconDrawWidth = iconBox.width * iconScale;
      const iconDrawHeight = iconBox.height * iconScale;
      const iconOffsetX = (iconSize - iconDrawWidth) / 2;
      const iconOffsetY = (iconSize - iconDrawHeight) / 2;
      iconGroup.setAttribute('transform', `translate(${start + iconOffsetX - iconBox.x * iconScale} ${artCenter.y - iconSize / 2 + iconOffsetY - iconBox.y * iconScale}) scale(${iconScale})`);
      iconGroup.classList.add('dynamic-icon');
      iconGroup.innerHTML = platform.icon;
      dynamicLayer.append(iconGroup);
    }
    if (hasOutlinedText) {
      const path = document.createElementNS(SVG_NS, 'path');
      path.setAttribute('d', pathData);
      path.classList.add('dynamic-text');
      path.setAttribute('transform', `translate(${start + iconWidth + spacer - pathBounds.x1} ${artCenter.y - (pathBounds.y1 + pathBounds.y2) / 2})`);
      dynamicLayer.append(path);
    }
    refreshPreviewMask();
  }

  function onPickerKeydown(event) {
    const directions = ['ArrowRight', 'ArrowLeft', 'Home', 'End'];
    if (!directions.includes(event.key)) return;
    const options = [...picker.querySelectorAll('.icon-option')];
    const current = options.indexOf(event.currentTarget);
    let next = current;
    if (event.key === 'Home') next = 0;
    else if (event.key === 'End') next = options.length - 1;
    else next = (current + (event.key === 'ArrowRight' ? 1 : -1) + options.length) % options.length;
    event.preventDefault();
    options[next].focus();
    choose(options[next].dataset.platform);
  }

  function onFontPickerKeydown(event) {
    const directions = ['ArrowRight', 'ArrowLeft', 'Home', 'End'];
    if (!directions.includes(event.key)) return;
    const options = [...fontPicker.querySelectorAll('.font-option')];
    const current = options.indexOf(event.currentTarget);
    let next = current;
    if (event.key === 'Home') next = 0;
    else if (event.key === 'End') next = options.length - 1;
    else next = (current + (event.key === 'ArrowRight' ? 1 : -1) + options.length) % options.length;
    event.preventDefault();
    options[next].focus();
    chooseFont(options[next].dataset.font);
  }

  function onQrStyleKeydown(event) {
    const directions = ['ArrowRight', 'ArrowLeft', 'Home', 'End'];
    if (!directions.includes(event.key)) return;
    const options = [...qrStylePicker.querySelectorAll('.qr-style-option')];
    const current = options.indexOf(event.currentTarget);
    let next = current;
    if (event.key === 'Home') next = 0;
    else if (event.key === 'End') next = options.length - 1;
    else next = (current + (event.key === 'ArrowRight' ? 1 : -1) + options.length) % options.length;
    event.preventDefault();
    options[next].focus();
    chooseQrStyle(options[next].dataset.qrStyle);
  }

  platforms.forEach((platform, index) => {
    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'icon-option';
    button.dataset.platform = platform.id;
    button.setAttribute('role', 'radio');
    button.setAttribute('aria-label', platform.name);
    button.setAttribute('aria-checked', 'false');
    button.tabIndex = index === 0 ? 0 : -1;
    button.innerHTML = iconMarkup(platform);
    button.addEventListener('click', () => choose(platform.id));
    button.addEventListener('keydown', onPickerKeydown);
    picker.append(button);
  });

  fonts.forEach((font, index) => {
    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'font-option';
    button.dataset.font = font.id;
    button.setAttribute('role', 'radio');
    button.setAttribute('aria-label', font.name);
    button.setAttribute('aria-checked', String(font.id === selectedFont));
    button.tabIndex = index === 0 ? 0 : -1;
    button.innerHTML = `<span class="font-sample" aria-hidden="true">${font.sample}</span><span class="font-name">${font.name}</span>`;
    button.addEventListener('click', () => chooseFont(font.id));
    button.addEventListener('keydown', onFontPickerKeydown);
    fontPicker.append(button);
  });

  qrStyles.forEach((style, index) => {
    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'qr-style-option';
    button.dataset.qrStyle = style.id;
    button.setAttribute('role', 'radio');
    button.setAttribute('aria-label', style.name);
    button.setAttribute('aria-checked', String(style.id === selectedQrStyle));
    button.tabIndex = index === 0 ? 0 : -1;
    button.innerHTML = `${qrStylePreviewMarkup(style)}<span class="qr-style-name">${style.name}</span>`;
    button.addEventListener('click', () => chooseQrStyle(style.id));
    button.addEventListener('keydown', onQrStyleKeydown);
    qrStylePicker.append(button);
  });

  root.querySelector('#scroll-left').addEventListener('click', () => picker.scrollBy({ left: -scrollAmount(), behavior: 'smooth' }));
  root.querySelector('#scroll-right').addEventListener('click', () => picker.scrollBy({ left: scrollAmount(), behavior: 'smooth' }));
  root.querySelector('#font-scroll-left').addEventListener('click', () => fontPicker.scrollBy({ left: -scrollAmount(), behavior: 'smooth' }));
  root.querySelector('#font-scroll-right').addEventListener('click', () => fontPicker.scrollBy({ left: scrollAmount(), behavior: 'smooth' }));
  root.querySelector('#qr-style-scroll-left').addEventListener('click', () => qrStylePicker.scrollBy({ left: -scrollAmount(), behavior: 'smooth' }));
  root.querySelector('#qr-style-scroll-right').addEventListener('click', () => qrStylePicker.scrollBy({ left: scrollAmount(), behavior: 'smooth' }));
  input.addEventListener('input', updatePreview);
  qrInput.addEventListener('input', updatePreview);
  choose('instagram');
  updateQrValidity();
  if (shopifyMode) {
    const productForm = addButton.form;
    productForm.addEventListener('submit', async (event) => {
      event.preventDefault();
      if (!selected) {
        picker.querySelector('.icon-option')?.focus();
        return;
      }
      syncCartProperties();
      addButton.disabled = true;
      try {
        const blob = await createVectorFile();
        if (!blob) return;
        const artwork = productForm.querySelector('[data-config-property="artwork"]');
        const transfer = new DataTransfer();
        transfer.items.add(new File([blob], safeFilename(input.value), { type: blob.type }));
        artwork.files = transfer.files;
        productForm.submit();
      } catch (error) {
        console.error('Could not prepare the QR sign Illustrator file for Shopify.', error);
        alert('The QR sign file could not be created. Please try again.');
      } finally {
        addButton.disabled = false;
      }
    });
  }

  function safeFilename(value) {
    let name = value
      .replace(/[<>:"/\\|?*\u0000-\u001f\u007f]/g, '')
      .replace(/^[ .]+|[ .]+$/g, '');
    if (!name) name = 'QR Code Sign';
    if (/^(con|prn|aux|nul|com[1-9]|lpt[1-9])(?:\..*)?$/i.test(name)) name = `_${name}`;
    return `${name}.ai`;
  }

  function makeExportSvg() {
    const svg = sign.cloneNode(true);
    svg.querySelector('#preview-outline-shadow')?.remove();
    svg.querySelector('#preview-rgb-overlay')?.remove();
    svg.querySelector('#preview-only-defs')?.remove();
    svg.setAttribute('xmlns', SVG_NS);
    svg.setAttribute('width', `${signSize.width * 25.4 / 96}mm`);
    svg.setAttribute('height', `${signSize.height * 25.4 / 96}mm`);

    const artwork = svg.querySelector('#thru-cut')?.parentElement;
    if (!artwork) throw new Error('Sign artwork is not ready.');
    const layers = [
      ['thru-cut', svg.querySelector('#thru-cut')],
      ['shallow-etch', svg.querySelector('#shallow-etch')],
      ['shallow-etch', svg.querySelector('#dynamic-shallow-etch')]
    ];
    const layerGroups = new Map();
    layers.forEach(([name, element]) => {
      if (!element) return;
      let group = layerGroups.get(name);
      if (!group) {
        group = document.createElementNS(SVG_NS, 'g');
        group.setAttribute('id', `export-${name}`);
        group.setAttribute('data-layer-name', name);
        layerGroups.set(name, group);
        artwork.append(group);
      }
      group.append(element);
    });
    artwork.setAttribute('transform', `translate(${signSize.width} 0) scale(-1 1)`);
    return svg;
  }

  function matrixMultiply(a, b) {
    return [
      a[0] * b[0] + a[2] * b[1], a[1] * b[0] + a[3] * b[1],
      a[0] * b[2] + a[2] * b[3], a[1] * b[2] + a[3] * b[3],
      a[0] * b[4] + a[2] * b[5] + a[4], a[1] * b[4] + a[3] * b[5] + a[5]
    ];
  }

  function parseTransform(value) {
    let matrix = [1, 0, 0, 1, 0, 0];
    const transforms = value.matchAll(/([a-z]+)\s*\(([^)]*)\)/gi);
    for (const [, name, args] of transforms) {
      const n = args.trim().split(/[\s,]+/).map(Number);
      let next = [1, 0, 0, 1, 0, 0];
      if (name === 'matrix' && n.length === 6) next = n;
      else if (name === 'translate') next = [1, 0, 0, 1, n[0], n[1] || 0];
      else if (name === 'scale') next = [n[0], 0, 0, n.length > 1 ? n[1] : n[0], 0, 0];
      else if (name === 'rotate') {
        const angle = n[0] * Math.PI / 180;
        const cos = Math.cos(angle);
        const sin = Math.sin(angle);
        const rotation = [cos, sin, -sin, cos, 0, 0];
        next = n.length > 2
          ? matrixMultiply(matrixMultiply([1, 0, 0, 1, n[1], n[2]], rotation), [1, 0, 0, 1, -n[1], -n[2]])
          : rotation;
      }
      matrix = matrixMultiply(matrix, next);
    }
    return matrix;
  }

  function postScriptPathData(data, matrix, pageHeight) {
    const tokens = data.match(/[-+]?(?:(?:\d+\.?\d*)|(?:\.\d+))(?:[eE][-+]?\d+)?|[a-z]/gi) || [];
    const output = [];
    const commandArgs = { M: 2, L: 2, H: 1, V: 1, C: 6, S: 4, Q: 4, T: 2, A: 7 };
    let index = 0;
    let command = '';
    let x = 0;
    let y = 0;
    let startX = 0;
    let startY = 0;
    let lastControl = null;
    let lastQuadratic = null;
    let previous = '';
    let contourOpen = false;
    const fmt = (n) => (Math.abs(n) < 0.000005 ? 0 : n).toFixed(5).replace(/0+$/, '').replace(/\.$/, '');
    const point = (px, py) => {
      const tx = matrix[0] * px + matrix[2] * py + matrix[4];
      const ty = matrix[1] * px + matrix[3] * py + matrix[5];
      return [tx * 0.75, pageHeight - ty * 0.75];
    };
    const move = (px, py) => {
      const p = point(px, py);
      output.push(`${fmt(p[0])} ${fmt(p[1])} m`);
    };
    const line = (px, py) => {
      const p = point(px, py);
      output.push(`${fmt(p[0])} ${fmt(p[1])} L`);
    };
    const cubic = (x1, y1, x2, y2, x3, y3) => {
      const p1 = point(x1, y1);
      const p2 = point(x2, y2);
      const p3 = point(x3, y3);
      output.push(`${fmt(p1[0])} ${fmt(p1[1])} ${fmt(p2[0])} ${fmt(p2[1])} ${fmt(p3[0])} ${fmt(p3[1])} C`);
    };
    const close = () => {
      if (contourOpen) output.push('h');
      contourOpen = false;
    };
    const arcCubics = (x1, y1, rx, ry, rotation, largeArc, sweep, x2, y2) => {
      rx = Math.abs(rx);
      ry = Math.abs(ry);
      if (!rx || !ry || (x1 === x2 && y1 === y2)) {
        line(x2, y2);
        return;
      }
      const phi = rotation * Math.PI / 180;
      const cos = Math.cos(phi);
      const sin = Math.sin(phi);
      const dx = (x1 - x2) / 2;
      const dy = (y1 - y2) / 2;
      const xp = cos * dx + sin * dy;
      const yp = -sin * dx + cos * dy;
      const ratio = xp * xp / (rx * rx) + yp * yp / (ry * ry);
      if (ratio > 1) { rx *= Math.sqrt(ratio); ry *= Math.sqrt(ratio); }
      const rx2 = rx * rx;
      const ry2 = ry * ry;
      const xp2 = xp * xp;
      const yp2 = yp * yp;
      const denominator = rx2 * yp2 + ry2 * xp2;
      const factor = denominator ? (largeArc === sweep ? -1 : 1) * Math.sqrt(Math.max(0, (rx2 * ry2 - rx2 * yp2 - ry2 * xp2) / denominator)) : 0;
      const cxp = factor * rx * yp / ry;
      const cyp = factor * -ry * xp / rx;
      const cx = cos * cxp - sin * cyp + (x1 + x2) / 2;
      const cy = sin * cxp + cos * cyp + (y1 + y2) / 2;
      const angle = (ux, uy, vx, vy) => Math.atan2(ux * vy - uy * vx, ux * vx + uy * vy);
      const ux = (xp - cxp) / rx;
      const uy = (yp - cyp) / ry;
      const vx = (-xp - cxp) / rx;
      const vy = (-yp - cyp) / ry;
      let theta = angle(1, 0, ux, uy);
      let delta = angle(ux, uy, vx, vy);
      if (!sweep && delta > 0) delta -= Math.PI * 2;
      if (sweep && delta < 0) delta += Math.PI * 2;
      const segments = Math.ceil(Math.abs(delta) / (Math.PI / 2));
      const step = delta / segments;
      const ellipsePoint = (t) => [cx + rx * cos * Math.cos(t) - ry * sin * Math.sin(t), cy + rx * sin * Math.cos(t) + ry * cos * Math.sin(t)];
      const ellipseTangent = (t) => [-rx * cos * Math.sin(t) - ry * sin * Math.cos(t), -rx * sin * Math.sin(t) + ry * cos * Math.cos(t)];
      for (let segment = 0; segment < segments; segment += 1) {
        const nextTheta = theta + step;
        const alpha = 4 / 3 * Math.tan((nextTheta - theta) / 4);
        const p0 = ellipsePoint(theta);
        const p1 = ellipsePoint(nextTheta);
        const t0 = ellipseTangent(theta);
        const t1 = ellipseTangent(nextTheta);
        cubic(p0[0] + alpha * t0[0], p0[1] + alpha * t0[1], p1[0] - alpha * t1[0], p1[1] - alpha * t1[1], p1[0], p1[1]);
        theta = nextTheta;
      }
    };

    while (index < tokens.length) {
      if (/^[a-z]$/i.test(tokens[index])) command = tokens[index++];
      if (!command) throw new Error('Unrecognized SVG path command.');
      const upper = command.toUpperCase();
      const relative = command !== upper;
      if (upper === 'Z') {
        close();
        x = startX;
        y = startY;
        lastControl = lastQuadratic = null;
        previous = upper;
        command = '';
        continue;
      }
      const count = commandArgs[upper];
      if (!count || index + count > tokens.length || /^[a-z]$/i.test(tokens[index])) throw new Error(`Invalid ${upper} path data.`);
      const args = tokens.slice(index, index + count).map(Number);
      index += count;
      const baseX = x;
      const baseY = y;
      if (upper === 'M') {
        const nx = args[0] + (relative ? baseX : 0);
        const ny = args[1] + (relative ? baseY : 0);
        close();
        x = startX = nx;
        y = startY = ny;
        move(x, y);
        contourOpen = true;
        command = relative ? 'l' : 'L';
      } else if (upper === 'L') {
        x = args[0] + (relative ? baseX : 0);
        y = args[1] + (relative ? baseY : 0);
        line(x, y);
      } else if (upper === 'H') {
        x = args[0] + (relative ? baseX : 0);
        line(x, y);
      } else if (upper === 'V') {
        y = args[0] + (relative ? baseY : 0);
        line(x, y);
      } else if (upper === 'C') {
        const ox = relative ? baseX : 0;
        const oy = relative ? baseY : 0;
        const values = [args[0] + ox, args[1] + oy, args[2] + ox, args[3] + oy, args[4] + ox, args[5] + oy];
        cubic(...values);
        x = values[4]; y = values[5]; lastControl = [values[2], values[3]];
      } else if (upper === 'S') {
        const ox = relative ? baseX : 0;
        const oy = relative ? baseY : 0;
        const c1 = ['C', 'S'].includes(previous) && lastControl ? [2 * baseX - lastControl[0], 2 * baseY - lastControl[1]] : [baseX, baseY];
        const c2 = [args[0] + ox, args[1] + oy];
        x = args[2] + ox; y = args[3] + oy;
        cubic(c1[0], c1[1], c2[0], c2[1], x, y);
        lastControl = c2;
      } else if (upper === 'Q' || upper === 'T') {
        const ox = relative ? baseX : 0;
        const oy = relative ? baseY : 0;
        const q = upper === 'Q'
          ? [args[0] + ox, args[1] + oy]
          : (['Q', 'T'].includes(previous) && lastQuadratic ? [2 * baseX - lastQuadratic[0], 2 * baseY - lastQuadratic[1]] : [baseX, baseY]);
        const end = upper === 'Q' ? [args[2] + ox, args[3] + oy] : [args[0] + ox, args[1] + oy];
        cubic(baseX + 2 / 3 * (q[0] - baseX), baseY + 2 / 3 * (q[1] - baseY), end[0] + 2 / 3 * (q[0] - end[0]), end[1] + 2 / 3 * (q[1] - end[1]), end[0], end[1]);
        x = end[0]; y = end[1]; lastQuadratic = q;
      } else if (upper === 'A') {
        const endX = args[5] + (relative ? baseX : 0);
        const endY = args[6] + (relative ? baseY : 0);
        arcCubics(baseX, baseY, args[0], args[1], args[2], Boolean(args[3]), Boolean(args[4]), endX, endY);
        x = endX; y = endY;
      }
      if (!['C', 'S'].includes(upper)) lastControl = null;
      if (!['Q', 'T'].includes(upper)) lastQuadratic = null;
      previous = upper;
    }
    close();
    return output.join('\n');
  }

  function collectLayerPaths(node, parentMatrix, pageHeight, paths, inheritedFillRule = 'nonzero') {
    const matrix = matrixMultiply(parentMatrix, parseTransform(node.getAttribute('transform') || ''));
    const fillRule = node.getAttribute('fill-rule') || inheritedFillRule;
    if (node.localName === 'path') {
      paths.push({ data: postScriptPathData(node.getAttribute('d') || '', matrix, pageHeight), fillRule });
      return;
    }
    Array.from(node.children).forEach((child) => collectLayerPaths(child, matrix, pageHeight, paths, fillRule));
  }

  function makeIllustratorFile(svg, filename) {
    const pageWidth = signSize.width * 72 / 96;
    const pageHeight = signSize.height * 72 / 96;
    const layerSpecs = [
      ['thru-cut', 'Black Cut', [0, 0, 0], 8],
      ['shallow-etch', 'Cyan Etch', [0, 174 / 255, 239 / 255], 6]
    ];
    const matrix = parseTransform(svg.querySelector('#export-thru-cut')?.parentElement?.getAttribute('transform') || '');
    const title = filename.replace(/[\\()]/g, '_');
    const lines = [
      '%!PS-Adobe-3.0 EPSF-3.0',
      '%%Creator: Adobe Illustrator 7.0',
      `%%Title: (${title})`,
      `%%BoundingBox: 0 0 ${Math.ceil(pageWidth)} ${Math.ceil(pageHeight)}`,
      `%%HiResBoundingBox: 0 0 ${pageWidth.toFixed(5)} ${pageHeight.toFixed(5)}`,
      '%%DocumentProcessColors: Black Cyan',
      `%AI5_FileFormat 2.0`,
      '%AI3_ColorUsage: Color',
      `%AI5_ArtSize: ${pageWidth.toFixed(5)} ${pageHeight.toFixed(5)}`,
      '%%AI5_NumLayers: 2',
      '%%EndComments',
      '%%BeginProlog',
      '%%EndProlog',
      '%%BeginSetup',
      '%%EndSetup'
    ];
    layerSpecs.forEach(([id, name, rgb, colorIndex]) => {
      const group = svg.querySelector(`#export-${id}`);
      if (!group) throw new Error(`Missing ${name} artwork.`);
      const paths = [];
      collectLayerPaths(group, matrix, pageHeight, paths);
      lines.push('%AI5_BeginLayer', `1 1 1 1 0 0 ${colorIndex} ${Math.round(rgb[0] * 255)} ${Math.round(rgb[1] * 255)} ${Math.round(rgb[2] * 255)} Lb`, `(${name}) Ln`);
      lines.push('u');
      paths.forEach((path) => lines.push('0 A', '0 XR', `${rgb.map((n) => n.toFixed(5)).join(' ')} Xa`, path.data, path.fillRule === 'evenodd' ? 'f*' : 'f'));
      lines.push('U');
      lines.push('LB', '%AI5_EndLayer--');
    });
    lines.push('%%Trailer', '%%EOF');
    return new Blob([lines.join('\n')], { type: 'application/vnd.adobe.illustrator;charset=utf-8' });
  }

  async function createVectorFile() {
    const qrResult = updateQrValidity();
    if (!qrResult.valid) {
      qrInput.focus();
      qrInput.reportValidity();
      return null;
    }
    if (!input.value.length) {
      input.focus();
      input.reportValidity();
      return null;
    }
    if (!selected) {
      picker.querySelector('.icon-option')?.focus();
      return null;
    }
    if (!dynamicLayer) {
      throw new Error('The sign artwork is still loading. Please try again.');
    }

    outlineFont = await loadFont(selectedFont);
    updatePreview();
    const svg = makeExportSvg();
    return makeIllustratorFile(svg, safeFilename(input.value));
  }

  async function exportVectorFile() {
    const blob = await createVectorFile();
    if (!blob) return;
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = safeFilename(input.value);
    document.body.append(link);
    link.click();
    link.remove();
    setTimeout(() => URL.revokeObjectURL(url), 1000);
  }

  if (!shopifyMode) {
    addButton.addEventListener('click', async () => {
      addButton.disabled = true;
      try {
        await exportVectorFile();
      } catch (error) {
        console.error('Could not export the Illustrator vector file.', error);
        alert('The QR sign file could not be created. Please try again.');
      } finally {
        addButton.disabled = false;
      }
    });
  }

  loadFont(selectedFont)
    .then((font) => {
      if (selectedFont === 'arial-black') outlineFont = font;
      picker.querySelectorAll('.icon-option').forEach((button) => {
        const item = platforms.find((platform) => platform.id === button.dataset.platform);
        button.innerHTML = iconMarkup(item);
      });
      if (selectedFont === 'arial-black') updatePreview();
    })
    .catch((error) => console.error('Could not load Arial Black for vector text.', error));

  fetch(root.dataset.baseSvgUrl || 'qr-code-config-v2-base.svg')
    .then((response) => {
      if (!response.ok) throw new Error(`Artwork request failed (${response.status}).`);
      return response.text();
    })
    .then((source) => {
      const base = new DOMParser().parseFromString(source, 'image/svg+xml').documentElement;
      const defs = base.querySelector('defs');
      if (defs) sign.append(document.importNode(defs, true));

      const previewShape = base.querySelector('#preview-outline')?.cloneNode(true);
      if (previewShape) {
        previewShape.removeAttribute('id');
        previewShape.removeAttribute('style');
        previewShape.removeAttribute('clip-path');
      }

      // Native SVG filtering keeps the silhouette shadow portable across browsers.
      // These definitions are preview-only and are removed from the export.
      const shadowFilter = document.createElementNS(SVG_NS, 'filter');
      shadowFilter.setAttribute('id', 'preview-silhouette-shadow');
      shadowFilter.setAttribute('x', '-20%');
      shadowFilter.setAttribute('y', '-20%');
      shadowFilter.setAttribute('width', '140%');
      shadowFilter.setAttribute('height', '140%');
      shadowFilter.setAttribute('color-interpolation-filters', 'sRGB');
      const shadowEffect = document.createElementNS(SVG_NS, 'feDropShadow');
      shadowEffect.setAttribute('dx', String(parseFloat(rgbSettings.getPropertyValue('--preview-shadow-x'))));
      shadowEffect.setAttribute('dy', String(parseFloat(rgbSettings.getPropertyValue('--preview-shadow-y'))));
      shadowEffect.setAttribute('stdDeviation', String(parseFloat(rgbSettings.getPropertyValue('--preview-shadow-blur'))));
      shadowEffect.setAttribute('flood-color', rgbSettings.getPropertyValue('--color-shadow').trim());
      shadowFilter.append(shadowEffect);
      sign.querySelector('#preview-only-defs').append(shadowFilter);

      const shadowOutline = previewShape?.cloneNode(true);
      if (shadowOutline) {
        shadowOutline.removeAttribute('id');
        shadowOutline.removeAttribute('class');
        shadowOutline.removeAttribute('style');
        shadowOutline.removeAttribute('clip-path');
        shadowOutline.setAttribute('id', 'preview-outline-shadow');
        shadowOutline.classList.add('preview-outline-shadow');
      }

      const mirrored = document.createElementNS(SVG_NS, 'g');
      ['thru-cut', 'shallow-etch'].forEach((id) => {
        const group = base.querySelector(`#${id}`);
        if (group) mirrored.append(document.importNode(group, true));
      });
      dynamicLayer = document.createElementNS(SVG_NS, 'g');
      dynamicLayer.setAttribute('id', 'dynamic-shallow-etch');
      dynamicLayer.classList.add('dynamic-shallow-etch');
      mirrored.append(dynamicLayer);
      const mask = document.createElementNS(SVG_NS, 'mask');
      mask.setAttribute('id', 'preview-rgb-mask');
      mask.setAttribute('maskUnits', 'userSpaceOnUse');
      mask.setAttribute('maskContentUnits', 'userSpaceOnUse');
      mask.setAttribute('mask-type', 'alpha');
      mask.setAttribute('x', '0');
      mask.setAttribute('y', '0');
      mask.setAttribute('width', String(signSize.width));
      mask.setAttribute('height', String(signSize.height));
      previewMaskArtwork = document.createElementNS(SVG_NS, 'g');
      previewMaskArtwork.classList.add('preview-mask');
      mask.append(previewMaskArtwork);
      sign.querySelector('#preview-only-defs').append(mask);

      const overlay = document.createElementNS(SVG_NS, 'rect');
      overlay.setAttribute('id', 'preview-rgb-overlay');
      overlay.setAttribute('x', '0');
      overlay.setAttribute('y', '0');
      overlay.setAttribute('width', String(signSize.width));
      overlay.setAttribute('height', String(signSize.height));
      overlay.setAttribute('mask', 'url(#preview-rgb-mask)');
      if (shadowOutline) sign.append(shadowOutline);
      sign.append(overlay, mirrored);
      updatePreview();
    })
    .catch((error) => console.error('Could not load the sign preview artwork.', error));
})();
